import { Renderer2 } from '@angular/core';
import * as numeral from 'numeral';
import { InputEditorBase } from 'app/slick-grid/models/input-editor-base';
import {TimeValidationParams} from "./time-validation-params";
import {Formatters} from "./formatters";
import {TranslateService} from "@ngx-translate/core";

export class TimeEditor<T extends Slick.SlickData> extends InputEditorBase<T> {
    constructor(protected readonly renderer: Renderer2,
                private readonly translateService: TranslateService,
                args: Slick.Editors.EditorOptions<T>,
                public readonly validationParams?: TimeValidationParams,
                validator?: (value: string, item: T, editor: TimeEditor<T>) => Slick.ValidateResults,
                public readonly allowNull?: boolean) {
        super(renderer, args, validator, null);

        this.clearBtn = this.renderer.createElement('button');
        this.clearBtn.textContent = 'x';
        this.translateService.get('Clear').subscribe(t => this.clearBtn.title = t);
        this.renderer.addClass(this.input, 'w-btn')
        this.renderer.addClass(this.clearBtn, 'clear-btn')
        this.renderer.listen(this.clearBtn, 'click', this.clearData);
        this.renderer.appendChild(this.args.container, this.clearBtn);

        this.input.type = 'time';
        //let data = args.item[args.column.field]
        // this.input.value = data ? `${data < 10 ? `0${data}` : data}:00` : null;
        // console.log(data, this.input.value, 'TimeEditor')
        if (this.validationParams){
            if (this.validationParams.step){
                this.input.step = this.validationParams.step.toString();
            }

            if (this.validationParams.startTime && this.validationParams.endTime){
                this.input.min = this.validationParams.startTime.toString();
                this.input.max = this.validationParams.endTime.toString();
            }

        }

    }

    private readonly clearBtn: HTMLButtonElement;
    public clear: boolean;

    isValueChanged(): boolean {
        return super.isValueChanged() || this.input.value !== this.getHtmlFormattedValue(this.args.item) || this.args.item[this.args.column.field] === null;
    }

    applyValue = (item: T, state: string): void => {
        item[this.args.column.field] = this.clear
            ? null
            : this.allowNull && !state
                ? null
                : state;
    }

    clearData = (): void => {
        this.clear = true;
        this.args.item[this.args.column.field] = null
        this.args.grid.getEditorLock().commitCurrentEdit();
    }

    protected getHtmlFormattedValue = (item: T): string => {
        let number;
        if (typeof item[this.args.column.field] === 'string'){
            number = numeral(item[this.args.column.field].slice(0, -3));
        } else {
            number = numeral(item[this.args.column.field]);
        }


        try {
            //console.log(number.value(), item[this.args.column.field], Formatters.timeFormatter2(null, null, number.value()), 'getHtmlFormattedValue')
            return Formatters.timeFormatter2(null, null, number.value())
        } finally {
            // numeral.locale(currentLocale);
        }
    }

    public readonly clone = (): TimeEditor<T> => {
        return new TimeEditor<T>(this.renderer, this.translateService, this.args, this.validationParams, this.validator, this.allowNull)
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/time-editor.ts